export enum skillType {
  pythonUtility,
  os,
  other,
  cli,
  softwareFramework,
  programmingLanguage,
  webDevelopment,
  developmentWorkflow,
  fileFormat,
  databaseDevelopment,
  ide,
  communication,
  deployment,
}

export interface skillEntry {
  name: string;
  imgPath?: string;
  imgAlt?: string;
  skillType: skillType;
}

export interface LinkCardEntry {
  imgPath: string;
  title?: string;
  imgAlt: string;
  text: string;
  linkPath?: string;
  clickMessageOverrideText?: string;
}

export interface PodiumEntry {
  name: string;
  imgPath: string;
}
